import { fetchAllList, fetchRelationIds } from 'share/services/api'
import { mapByIds } from 'share/services/utils'

export default ['Resty', (Resty) => Resty('user_groups', klass => {
  klass.loadFormData = (id, config = {}) => Promise.all([
    fetchAllList('users', config.userRoles ? { role_in: config.userRoles } : {}),
    klass.fetchOne(id).then(userGroup => userGroup.loadNestedResourcesCount('workflows')),
    fetchRelationIds(`/user_groups/${id}/users.ids`)
  ]).then(([users, userGroup, userIds]) => {
    userGroup.$users = mapByIds(users, userIds);
    return [users, userGroup];
  })
})];
